export function extractYear(date: string): string {
  if (date.length === 6 && /^\d{6}$/.test(date)) return date.substring(0, 4);
  if (date.length === 10 && date.includes('-')) return date.split('-')[0];
  return date;
}

export function filterDataByPeriod(
  data: Map<number, Map<string, number>>,
  period: string
): Map<number, Map<string, number>> {
  if (period === 'all') return data;

  const filtered = new Map<number, Map<string, number>>();
  for (const [categoryCode, dateMap] of data.entries()) {
    const filteredDateMap = new Map<string, number>();
    for (const [date, value] of dateMap.entries()) {
      if (extractYear(date) === period) {
        filteredDateMap.set(date, value);
      }
    }
    if (filteredDateMap.size > 0) {
      filtered.set(categoryCode, filteredDateMap);
    }
  }
  return filtered;
}
